import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/CopySimple.es.js";
const e = o.forwardRef((m, p) => /* @__PURE__ */ o.createElement(r, { ref: p, ...m, weights: t }));
e.displayName = "CopySimpleIcon";
const c = e;
export {
  c as CopySimple,
  e as CopySimpleIcon
};
